import { usePostAuthApi } from './UseApiCalls';
import type { CreateFeedbackRequest, FeedbackDetail } from '@/api/feedbackApi';

/**
 * Submitting is all the app does with feedback: the server forwards it to
 * Sprints, where reports are triaged. Reading and managing them used to happen
 * in /management/feedback, which was removed in favour of the Sprints board.
 */
export function useCreateFeedback() {
  return usePostAuthApi<FeedbackDetail, CreateFeedbackRequest>('feedback');
}
